import { render, staticRenderFns } from "./ForeignerForm.vue?vue&type=template&id=677247fe&"
import script from "./ForeignerForm.vue?vue&type=script&lang=js&"
export * from "./ForeignerForm.vue?vue&type=script&lang=js&"
import style0 from "./ForeignerForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports